import * as React from 'react';
import clsx from 'clsx';
import pick from 'lodash/pick';
var styles = {
  "all": "Hide-all_3co9V",
  "xsm": "Hide-xsm_f6bSR",
  "sm": "Hide-sm_1tyH4",
  "md": "Hide-md_hkOa8",
  "lg": "Hide-lg_2JRqy",
  "xlg": "Hide-xlg_3afZI",
  "xxlg": "Hide-xxlg_ca5wp",
  "wd": "Hide-wd_3D2DV",
  "xwd": "Hide-xwd_27Uis",
  "from-xsm": "Hide-from-xsm_3V2ry",
  "from-sm": "Hide-from-sm_K7cQm",
  "from-md": "Hide-from-md_3Zxuu",
  "from-lg": "Hide-from-lg_stK8F",
  "from-xlg": "Hide-from-xlg_qkEGr",
  "from-xxlg": "Hide-from-xxlg_7ijUe",
  "from-wd": "Hide-from-wd_2OHJF",
  "from-xwd": "Hide-from-xwd_3vaTS",
  "until-xsm": "Hide-until-xsm_ge1CD",
  "until-sm": "Hide-until-sm_1vxoe",
  "until-md": "Hide-until-md_BdHvw",
  "until-lg": "Hide-until-lg_1k7x7",
  "until-xlg": "Hide-until-xlg_1do7g",
  "until-xxlg": "Hide-until-xxlg_1eXl5",
  "until-wd": "Hide-until-wd_9lZki",
  "until-xwd": "Hide-until-xwd_1QT3u",
  "nojs": "Hide-nojs_1LmLa",
  "print": "Hide-print_2WojK"
};
function Hide(props) {
  const {
    xsm,
    sm,
    md,
    lg,
    xlg,
    xxlg,
    wd,
    xwd,
    at,
    from,
    until,
    nojs,
    print,
    component,
    tagName = 'span',
    className,
    children,
    ...extraProps
  } = props;
  const hasBreapoint = Object.values(pick(props, ['xsm', 'sm', 'md', 'lg', 'xlg', 'xxlg', 'wd', 'xwd', 'at', 'from', 'until', 'nojs', 'print'])).some(Boolean);
  const rootClasses = clsx({
    [styles.all]: !hasBreapoint,
    [styles.xsm]: xsm,
    [styles.sm]: sm,
    [styles.md]: md,
    [styles.lg]: lg,
    [styles.xlg]: xlg,
    [styles.xxlg]: xxlg,
    [styles.wd]: wd,
    [styles.xwd]: xwd,
    [styles.nojs]: nojs,
    [styles.print]: print
  }, at && styles[at], from && styles[`from-${from}`], until && styles[`until-${until}`], className);
  if (component && /*#__PURE__*/React.isValidElement(component)) {
    return /*#__PURE__*/React.cloneElement(component, {
      className: clsx(component.props.className, rootClasses),
      ...extraProps
    });
  }
  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(tagName, {
      className: clsx(className, rootClasses),
      ...extraProps
    }, children);
  }
  return React.Children.toArray(children).map(child => /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
    className: clsx(child.props.className, rootClasses),
    ...extraProps
  }) : child);
}
Hide.displayName = 'Hide';
export { Hide };